import { render, staticRenderFns } from "./budgetResultInfo.vue?vue&type=template&id=6bb83d12"
import script from "./budgetResultInfo.vue?vue&type=script&lang=js"
export * from "./budgetResultInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb83d12')) {
      api.createRecord('6bb83d12', component.options)
    } else {
      api.reload('6bb83d12', component.options)
    }
    module.hot.accept("./budgetResultInfo.vue?vue&type=template&id=6bb83d12", function () {
      api.rerender('6bb83d12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/budget/budgetResultInfo.vue"
export default component.exports